import axios from 'axios';
import {Message} from 'element-ui'
import { startLoading,endLoading } from "./loading"
import router from "@/router"
/* 获取auctionSessionId */
const getSessionId = () => {
  return sessionStorage.auctionSessionId || ""
}

var service = axios.create({
  // baseURL: process.env.BASE_API,
  baseURL:"/hxkj_paimai_server_api",
  timeout: 50000,
  headers: {
    'X-Custom-Header': 'foobar'
  }
});
/* 添加请求拦截器 */
service.interceptors.request.use((config) => {
  // console.log("添加请求拦截器", config, );
  // startLoading()
  /* 添加请求头 */
  config.headers['sessionId'] = getSessionId()
  //  给每次请求加一个时间戳
  if (config.method == 'get') {
    // console.log("hkkkkkkkkkkkk----------")
    if (!config.params) {
      config.params = {
        '_t': new Date().getTime()
      }
    } else {
      config.params['_t'] = new Date().getTime()
    }
  }
  return config;
}, function (error) {
  // console.log(error,"222222222222222222222")
  // 对请求错误做些什么
  return Promise.reject(error);
});

/*  添加响应拦截器 */
service.interceptors.response.use((response) => {
  // endLoading()
  // console.log("333333333", response);
  // if (response.status != 200) {
  //     return Promise.reject(error);
  // }
  const data = response.data;
  if (data instanceof Blob) {
    return data
  }
  if (data.code == 1) {
    // 对响应数据做点什么
    return response;
  } else if (
    data.code == 100002 || 
    data.code == 120001 || 
    data.code == 120002 || 
    data.code == 100003 || 
    data.code == 100004 ||
    data.code == -21 ||
    data.code == -22 ||
    data.code == -16
    ) {
    Message({
      message: response.data.msg,
      type: 'warning'
    });
    return response;
  } else if(data.code == -1) {
    // console.log("123333")
    Message.closeAll()
    sessionStorage.removeItem('auctionSessionId')
    sessionStorage.removeItem('auctionAccount')  
    Message({
      message: "登录失效，请重新登录",
      // message: data.msg,
      type: 'error',
      duration: 2000,
      onClose: function() {
        router.push("/home/auctionLogin");
      }
    });
    // return response;
  }
  
  else {
    if (response.config.url == "/com/sys/sys_user/login") {
      return response
    } else if ('文件不存在' != response.data.msg) {
      Message({
        message: response.data.msg,
        type: 'error'
      });
      return Promise.reject(response.data.msg);
    }

  }

}, function (error) {
  // 对响应错误做点什么
  Message({
    message: "网络超时,请稍后重试",
    type: 'error'
  });
  // endLoading()
  return Promise.reject(error);
});
export default service;



// WEBPACK FOOTER //
// ./src/util/request1.js